





























































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  ContactInformation,
  FetchState
} from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import PoAwareAddress from "@/employee/components/shared/Address.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";

const demoConfirm = {
  name: false,
  dob: false,
  mailingAddress: false,
  physicalAddress: false,
};

type DemoConfirm = typeof demoConfirm;

type DemoConfirmStep = keyof (DemoConfirm);

@Component({
  components: {
    GenericLoadingSpinner,
    PoAwareAddress,
  }
})
export default class DemographicConfirmation extends Vue {
  completedSteps: DemoConfirm = { ...demoConfirm };
  readonly steps: DemoConfirmStep[] = [ "name", "dob", "mailingAddress", "physicalAddress" ];

  contactInfoStore = useContactInfoStore();

  mounted () {
    this.contactInfoStore.getContactInformation();
  }

  get isLoaded () {
    return this.contactInfoStore.contactInformationState === FetchState.Loaded;
  }

  get currentStep () {
    // first instance in this.steps where it is not already complete
    return this.steps.find(s => !this.completedSteps[s]);
  }

  get isCurrentLastStep () {
    return this.currentStep === this.steps[this.steps.length - 1];
  }

  get isName () {
    return this.currentStep === "name";
  }

  get isDob () {
    return this.currentStep === "dob";
  }

  get isPhysicalAdderss () {
    return this.currentStep === "physicalAddress";
  }

  get isMailingAddress () {
    return this.currentStep === "mailingAddress";
  }

  get contactInfoRoute () {
    return { name: RouteNames.NamedOnboarding, params: { stepKey: "personal-details" } };
  }

  completeCurrentStep () {
    if (!this.currentStep) {
      return;
    } // no current step, so exit early

    Vue.set(this.completedSteps, this.currentStep, true);
  }

  onAllConfirmed () {
    this.contactInfoStore.userDidConfirmInfo();
  }

}
